import { render } from "./propagateDetails.vue?vue&type=template&id=17201a8c"
import script from "./propagateDetails.vue?vue&type=script&lang=js"
export * from "./propagateDetails.vue?vue&type=script&lang=js"

import "./propagateDetails.vue?vue&type=style&index=0&id=17201a8c&lang=scss"

import exportComponent from "/Users/wlxqxxf/铭方营养/nutrition-web-wechat/node_modules/_vue-loader@16.8.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__